import { EmployeeDepartmentFilterValue } from "@/pages/employees/index/EmployeeDepartmentFilterValue.tsx";
import {
  EmployeeJobProfileFilterValue,
  EmployeeJobRoleFilterValue,
} from "@/pages/employees/index/EmployeeJobFilterValues.tsx";
import { EmployeeColumnFilterRenderers } from "@/pages/employees/index/employee-column-filter-renderers.ts";

export const EMPLOYEE_FILTER_RENDERERS: EmployeeColumnFilterRenderers = {
  byColumn: {
    "employee.position.department": (props) => <EmployeeDepartmentFilterValue {...props} />,
    "employee.position.job_profile": (props) => <EmployeeJobProfileFilterValue {...props} />,
    "employee.position.job_role": (props) => <EmployeeJobRoleFilterValue {...props} />,
  },
};
